__turbopack_context__.v({
  "closeBtn": "accessRequestModal-module-scss-module__DvXa3a__closeBtn",
  "form": "accessRequestModal-module-scss-module__DvXa3a__form",
  "isFormLoadingSpinner": "accessRequestModal-module-scss-module__DvXa3a__isFormLoadingSpinner",
  "labelBlock": "accessRequestModal-module-scss-module__DvXa3a__labelBlock",
  "modal": "accessRequestModal-module-scss-module__DvXa3a__modal",
});
